import { render, staticRenderFns } from "./InsertMeta.vue?vue&type=template&id=54449763"
import script from "./InsertMeta.vue?vue&type=script&lang=js"
export * from "./InsertMeta.vue?vue&type=script&lang=js"
import style0 from "./InsertMeta.vue?vue&type=style&index=0&id=54449763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports